/**
 * PromptCard - what Pip is asking for, and proof that the game is listening.
 *
 * Bottom of the screen, in the thumb zone, because ninety percent of sessions
 * are on a phone held by an adult sitting beside the child.
 *
 * ---------------------------------------------------------------------------
 * THE LISTENING RING IS NOT DECORATION
 *
 * It scales with the microphone's RMS and lights up the instant the detector
 * says the child is vocalising - the same signal that scores Phase 1 component
 * B. For a pre-verbal child that is the whole point: making ANY sound visibly
 * does something, immediately, before any word exists. A game that only reacts
 * to recognised words tells that child their voice does nothing.
 */

export default function PromptCard({ prompt, cue, chips, hint, listening, interim, rungId }) {
  const level = Math.max(0, Math.min(1, (listening.rms || 0) * 14));

  return (
    <div className="bp-prompt" data-rung={rungId}>
      <div className="bp-prompt__row">
        <div
          className={`bp-mic${listening.isVocalising ? ' is-vocalising' : ''}${listening.monitored ? '' : ' is-unmonitored'}`}
          style={{ '--level': level }}
          aria-hidden="true"
        >
          <span className="bp-mic__ring" />
          <span className="bp-mic__core" />
        </div>

        <div className="bp-prompt__text">
          <p className="bp-prompt__line">{prompt}</p>
          {hint && <p className="bp-prompt__hint">{hint}</p>}
          {interim && <p className="bp-prompt__interim">{interim}</p>}
        </div>

        {cue && (
          <div className={`bp-cue bp-cue--${cue.kind}`} aria-label={`Clue: ${cue.text}`}>
            {cue.text}
          </div>
        )}
      </div>

      {chips && chips.length > 0 && (
        <div className="bp-chips" aria-label="Words you can use">
          {chips.map((chip) => (
            <span key={chip.id} className="bp-chip">
              <span className="bp-chip__art" aria-hidden="true">{chip.art}</span>
              {chip.label}
            </span>
          ))}
          <span className="bp-chip bp-chip--blank">…</span>
        </div>
      )}
    </div>
  );
}
